import { useCallback } from "react"
import { useApolloClient, gql } from "@apollo/client"
import { LogError } from "../helpers/logger"

const CHECK_EMAIL = gql`
  query ParticipantEmailChecker(
    $email: String!
    $participant_id: ID!
    $organization_id: ID!
  ) {
    participantEmailAddressVerifier(
      email: $email
      participant_id: $participant_id
      organization_id: $organization_id
    ) {
      data
    }
  }
`

export default function useParticipantEmailChecker() {
  const client = useApolloClient()

  const checkParticipantEmail = useCallback(
    async (args) => {
      const {
        email,
        participant_id,
        organization_id,
        current_participant_id,
        typeForm,
      } = args
      if (!email || !organization_id) return true

      try {
        const result = await client.query({
          query: CHECK_EMAIL,
          fetchPolicy: "network-only",
          variables: {
            email: email.toLowerCase(),
            participant_id: participant_id || "",
            organization_id: organization_id || "",
          },
        })

        const dataRes = result?.data?.participantEmailAddressVerifier?.data

        if (!dataRes) return true // empty string = available

        // Edit mode: allow if the duplicate is the participant's own current email
        if (typeForm !== "template" && dataRes === current_participant_id)
          return true

        return false
      } catch (err) {
        LogError("checkParticipantEmail error", err)
        return false // Fail uniqueness check on error to be safe
      }
    },
    [client],
  )

  return { checkParticipantEmail }
}
